import { createSlice, combineReducers } from "@reduxjs/toolkit";
import { get_login_user_details } from "../Actions/AuthUser";

interface UserDetail {
  _id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  profileImage?: string;
  userType?: string;
  isAgreedOnPolicy?: boolean;
  isPasswordChanged?: boolean;
}

interface LoginUserState {
  userDetail: UserDetail;
  status: "idle" | "loading" | "success" | "failed";
}
const initialState: LoginUserState = {
  userDetail: {},
  status: "idle",
};

export const loginUserDetails = createSlice({
  name: "loginUserDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(get_login_user_details.pending, (state) => {
        state.status = "loading";
      })
      .addCase(get_login_user_details.fulfilled, (state, action) => {
        state.userDetail = action.payload;
        state.status = "success";
      })
      .addCase(get_login_user_details.rejected, (state) => {
        state.userDetail = {};
        state.status = "failed";
      });
  },
});

export default combineReducers({
  loggedInUserDetails: loginUserDetails.reducer,
});
